import { ItineraryEventType, Maybe } from 'core/graphql/types';

export interface EventStatusIndicatorProps {
  eventType: Maybe<ItineraryEventType> | undefined;
}

const EventStatusIndicator = ({ eventType }: EventStatusIndicatorProps) => {
  if (eventType === ItineraryEventType.Delivery) {
    return (
      <div className="rounded-sm bg-design-green p-2 text-design-black">
        Delivery
      </div>
    );
  }
  if (eventType === ItineraryEventType.Cancellation) {
    return (
      <div className="rounded-sm bg-yellow p-2 text-design-black">
        Cancellation
      </div>
    );
  }
  if (eventType === ItineraryEventType.Pickup) {
    return (
      <div className="rounded-sm bg-magenta p-2 text-design-black">Pickup</div>
    );
  }
  if (eventType === ItineraryEventType.StandardRetour) {
    return (
      <div className="rounded-sm bg-pink p-2 text-design-black">
        Standard Retour
      </div>
    );
  }
  if (eventType === ItineraryEventType.PickPackRetour) {
    return (
      <div className="rounded-sm bg-pink p-2 text-design-black">
        Pick Pack Retour
      </div>
    );
  }
  if (eventType === ItineraryEventType.LockerVisit) {
    return (
      <div className="rounded-sm bg-bright-blue p-2 text-white">
        Locker Visit
      </div>
    );
  }
  if (eventType === ItineraryEventType.PudoVisit) {
    return (
      <div className="rounded-sm bg-orange p-2 text-white">
        PUDO Visit
      </div>
    );
  }
  if (eventType === ItineraryEventType.C2CPickup) {
    return (
      <div className="rounded-sm bg-dark-blue p-2 text-white">
        C2C Pickup
      </div>
    );
  }
  return (
    <div className="text-text-white rounded-sm bg-muted-white p-2 dark:bg-design-secondary-black">
      {eventType}
    </div>
  );
};

export default EventStatusIndicator;
